// Thin client for POST /api/users/bootstrap.
// Idempotent on the server side — calling this is a no-op once the user
// already holds every bootstrap-time achievement.
import { supabase } from "@/lib/supabase";
import type { AdsActivityFreshAchievement } from "@/lib/adsAssistantClientEngagement";

export const USERS_BOOTSTRAP_PATH = "/api/users/bootstrap";

export type UsersBootstrapResponse =
  | { ok: true; fresh_achievements: AdsActivityFreshAchievement[]; skipped?: string }
  | { ok: false; error: string };

export async function runUserBootstrap(): Promise<UsersBootstrapResponse> {
  if (!supabase) return { ok: false, error: "App is not configured for sign-in." };

  const {
    data: { session },
  } = await supabase.auth.getSession();
  const token = session?.access_token;
  if (!token) return { ok: false, error: "Sign in to run bootstrap." };

  try {
    const r = await fetch(USERS_BOOTSTRAP_PATH, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: "{}",
    });
    const text = await r.text();
    let json: unknown = null;
    try {
      json = JSON.parse(text);
    } catch {
      /* non-JSON */
    }

    if (!r.ok) {
      const err =
        json && typeof json === "object" && json !== null && "error" in json &&
        typeof (json as { error: unknown }).error === "string"
          ? (json as { error: string }).error
          : text || `HTTP ${r.status}`;
      return { ok: false, error: err };
    }

    return json as UsersBootstrapResponse;
  } catch (err) {
    return { ok: false, error: err instanceof Error ? err.message : String(err) };
  }
}
